(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $b7dd635ddf413e81$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL("gTtyq"), JSON.parse('["gTtyq","index.24c7fd9f.js","ePnFz","../carte-topo.c072b3db.png","eyHkt","../mic.d05ce39f.png","aZmjP","../TestLR.c41b1ab3.m4a","eebaD","../SoundEscape.ddf2b7c4.m4a","l73F6","../DescriptionAlo.e3845da4.m4a","4IQov","../DescriptionBern.3fbe4433.m4a","6DVEI","../DescriptionIsa.f07d445e.m4a","gDZAY","../DescriptionLeon.433bd7ac.m4a","30xQT","../DescriptionLouve.f90e36c0.m4a","2YiM7","../DescriptionMic.9f0ecbff.m4a","hqMYh","../DescriptionNico.3671b546.m4a","3PwVN","../DescriptionVJ.66bb408d.m4a","8mmvm","../DescriptionYves.aaa963cc.m4a"]'));

// Autrona Acoustic Computer Kernel Module: Audio
// Main Web Audio API module, takes care of creating and resuming
// Audio context, maintaining sources and providing some effects.
var $12429086d032ace0$exports = {};

$parcel$export($12429086d032ace0$exports, "load", function () { return $12429086d032ace0$export$11e63f7b0f3d9900; });
$parcel$export($12429086d032ace0$exports, "play", function () { return $12429086d032ace0$export$899fbdb5fa08b653; });
$parcel$export($12429086d032ace0$exports, "audioBuffers", function () { return $12429086d032ace0$export$c2a342ec653dfb48; });
// Audio kernel module: Buffer
// Manages loading, decoding and plaback of audioBuffers

// References
const $12429086d032ace0$export$c2a342ec653dfb48 = {};
function $12429086d032ace0$export$11e63f7b0f3d9900(name, url, progress = null) {
    const request = new XMLHttpRequest();
    const promise = new Promise((resolve, reject)=>{
        request.open("GET", url, true);
        request.responseType = "arraybuffer";
        request.onload = ()=>{
            resolve($12429086d032ace0$var$decode(name, request.response));
        };
        request.onerror = ()=>{
            reject();
            console.error(`An error occured while getting '${name}' audio from '${url}'`);
        };
        request.onprogress = (e)=>{
            const percent = Math.round(e.loaded / e.total * 100);
            if (typeof progress === "function") progress(percent);
            if (DEVMODE) console.log(`Progress loading '${name}' audio file`, percent + "%");
        };
        request.send();
    });
    return promise;
}
function $12429086d032ace0$var$decode(name, arrayBuffer) {
    const promise = new Promise((resolve, reject)=>{
        $2f9e349157582da0$export$a078c61943f9dbbe.decodeAudioData(arrayBuffer, (buffer)=>{
            $12429086d032ace0$export$c2a342ec653dfb48[name] = buffer;
            resolve();
            if (DEVMODE) console.log(`Decoded '${name}' audio buffer`);
        }, (e)=>{
            reject();
            console.error("Error while decoding audio data: " + e);
        });
    });
    return promise;
}
function $12429086d032ace0$export$899fbdb5fa08b653(name, options = {}) {
    if ($12429086d032ace0$export$c2a342ec653dfb48[name] === undefined) {
        console.error(`Play error: '${name}' audio buffer does not exist.`);
        return false;
    }
    $2f9e349157582da0$export$fbb4d68fe60c1629();
    // Create a new source
    const source = $2f9e349157582da0$export$a078c61943f9dbbe.createBufferSource();
    const gainNode = $2f9e349157582da0$export$a078c61943f9dbbe.createGain();
    if (options.initialGain != undefined) // Note: this initial gain value will only be applied after that time
    // have passed (it does not change immediately).
    gainNode.gain.setValueAtTime($2f9e349157582da0$export$33ed28de027e9482(options.initialGain), $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
    source.gainNode = gainNode; // custom property for reference
    source.fadeTo = $2f9e349157582da0$export$549ee30ac73cf40b; // custom function
    source.fade = $2f9e349157582da0$export$cbea29d068a2e18f; // custom function
    source.connect(gainNode);
    gainNode.connect(options.destination || $2f9e349157582da0$export$a078c61943f9dbbe.destination);
    // Optional looping parameters
    source.loop = options.loop || false;
    source.loopStart = options.loopStart || 0;
    source.loopEnd = options.loopEnd || 0;
    // Optional starting parameters
    const when = (options.when || 0) + $2f9e349157582da0$export$a078c61943f9dbbe.currentTime;
    const offset = options.offset || 0;
    const duration = options.duration || undefined;
    // ... more options to come (detune, playBackRate)?
    // Assign an already loaded and decoded buffer
    source.buffer = $12429086d032ace0$export$c2a342ec653dfb48[name];
    // On ended event
    source.onended = ()=>{
        if (typeof options.onended === "function") options.onended();
        $2f9e349157582da0$export$93c25f2590a5b540(source);
    };
    // Start producing sound
    if (options.defer === undefined) source.start(when, offset, duration);
    // Maintain references to this source
    $2f9e349157582da0$export$d1d41f0cda037248.push(source);
    return source;
}


// References
let $2f9e349157582da0$export$a078c61943f9dbbe;
const $2f9e349157582da0$export$d1d41f0cda037248 = [];
function $2f9e349157582da0$export$2cd8252107eb640b() {
    // Create AudioContext
    if (typeof AudioContext !== "undefined") $2f9e349157582da0$export$a078c61943f9dbbe = new AudioContext();
    else // For Safari
    $2f9e349157582da0$export$a078c61943f9dbbe = new webkitAudioContext();
    if (DEVMODE) console.log("Audio context sample rate: " + $2f9e349157582da0$export$a078c61943f9dbbe.sampleRate);
}
function $2f9e349157582da0$export$fbb4d68fe60c1629() {
    // Resume context, dealing with autoplay policy
    if ($2f9e349157582da0$export$a078c61943f9dbbe.state === "suspended") {
        if (DEVMODE) console.log("Resuming AudioContext");
        return $2f9e349157582da0$export$a078c61943f9dbbe.resume();
    } else return Promise.resolve();
}
// Fade to an absolute level in db
// Default to a fade in behavior from -90db
// this function is used as a source method 
function $2f9e349157582da0$export$549ee30ac73cf40b(time = 2, level = 0, fromLevel = -90, mode = "linear") {
    this.gainNode.gain.setValueAtTime($2f9e349157582da0$export$33ed28de027e9482(fromLevel), $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime($2f9e349157582da0$export$33ed28de027e9482(level), $2f9e349157582da0$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime($2f9e349157582da0$export$33ed28de027e9482(level), $2f9e349157582da0$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
// Fade to a new level by applying a relative db gain
// Defaults to a fade out behavior
// this function is used as a source method 
function $2f9e349157582da0$export$cbea29d068a2e18f(time = 2, db = -90, andStop = false, mode = "linear") {
    const currentGain = this.gainNode.gain.value;
    // This setValueAtTime call below is required for Firefox and Safari.
    // Otherwise, linearRampToValueAtTime will do nothing until
    // ac.currentTime + time is reached and then immeditaley drop to -90db.
    // Is this a bug?
    this.gainNode.gain.setValueAtTime(currentGain, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime(currentGain * $2f9e349157582da0$export$33ed28de027e9482(db), $2f9e349157582da0$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime(currentGain * $2f9e349157582da0$export$33ed28de027e9482(db), $2f9e349157582da0$export$a078c61943f9dbbe.currentTime + time);
    if (andStop) this.stop($2f9e349157582da0$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
function $2f9e349157582da0$export$51b36263b660c3ee(time = 2, finalGain = -90) {
    // Fade out all sources and stop them
    $2f9e349157582da0$export$d1d41f0cda037248.forEach((s)=>s.fade(time, finalGain, true));
}
function $2f9e349157582da0$export$33390c3a9a83a2f() {
    $2f9e349157582da0$export$d1d41f0cda037248.forEach((s)=>s.stop());
}
function $2f9e349157582da0$export$93c25f2590a5b540(source) {
    const index = $2f9e349157582da0$export$d1d41f0cda037248.indexOf(source);
    $2f9e349157582da0$export$d1d41f0cda037248.splice(index, 1);
}
function $2f9e349157582da0$export$e2eaa0ea75f89eaa(gain) {
    return 20 * log10(gain);
    function log10(x) {
        return Math.log(x) / Math.LN10;
    }
}
function $2f9e349157582da0$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}




let $19e595a4b41a11be$var$testHeadphone;
function $19e595a4b41a11be$export$2cd8252107eb640b() {
    document.querySelector(".js-start").addEventListener("click", ()=>{
        if (DEVMODE) console.log("Starting...");
        document.querySelector(".headphone").classList.add("hidden");
        document.querySelector(".js-start").classList.add("hidden");
        document.querySelector(".center").classList.add("hidden");
        document.querySelector(".screen").classList.remove("hidden");
        $2f9e349157582da0$export$fbb4d68fe60c1629().then(()=>{
            if ($19e595a4b41a11be$var$testHeadphone) $19e595a4b41a11be$var$testHeadphone.fade(1);
            $aeba43b1d865609c$export$b3571188c770cc5a();
        });
    });
    document.querySelector(".js-test-headphone").addEventListener("click", $19e595a4b41a11be$var$testHeadphones);
}
function $19e595a4b41a11be$export$471f7ae5c4103ae1(status) {
    const statusEl = document.querySelector("#status");
    if (status === null) statusEl.classList.add("hidden");
    else statusEl.classList.remove("hidden");
    statusEl.innerText = status;
}
function $19e595a4b41a11be$export$4bb981a91e4f02eb() {
    document.querySelector(".headphone").classList.remove("hidden");
    document.querySelector(".js-start").classList.remove("hidden");
    $19e595a4b41a11be$export$471f7ae5c4103ae1(null);
}
function $19e595a4b41a11be$var$testHeadphones() {
    const leftIndicator = document.querySelector(".test-headphone-left");
    const rightIndicator = document.querySelector(".test-headphone-right");
    $2f9e349157582da0$export$fbb4d68fe60c1629().then(()=>{
        $19e595a4b41a11be$var$testHeadphone = $12429086d032ace0$exports.play("test-headphone", {
            onended: ()=>{
                rightIndicator.style.opacity = 0;
            }
        });
    });
    leftIndicator.style.opacity = 1;
    setTimeout(()=>{
        leftIndicator.style.opacity = 0;
        rightIndicator.style.opacity = 1;
    }, 8000);
}



// Audio kernel module: Panner
// Manages audiospatialisation

function $6992b783e25448c7$export$604289ae06b8fa82(options = {}) {
    const panner = $2f9e349157582da0$export$a078c61943f9dbbe.createPanner();
    panner.panningModel = "HRTF";
    panner.distanceModel = "inverse";
    panner.refDistance = 20;
    panner.maxDistance = 2000;
    panner.rolloffFactor = 1;
    panner.coneInnerAngle = 360;
    panner.coneOuterAngle = 0;
    panner.coneOuterGain = 0;
    if (panner.orientationX) {
        panner.orientationX.setValueAtTime(0, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
        panner.orientationY.setValueAtTime(0, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
        panner.orientationZ.setValueAtTime(-1, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
    } else panner.setOrientation(0, 0, -1);
    panner.positionPanner = function(x, y, z) {
        if (panner.positionX) {
            panner.positionX.setValueAtTime(x, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
            panner.positionY.setValueAtTime(y, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
            panner.positionZ.setValueAtTime(z, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
        } else panner.setPosition(x, y, z);
    };
    panner.connect(options.destination || $2f9e349157582da0$export$a078c61943f9dbbe.destination);
    return panner;
}
function $6992b783e25448c7$export$f0551cbb67220cad(x, y, z) {
    const listener = $2f9e349157582da0$export$a078c61943f9dbbe.listener;
    if (listener.positionX) {
        listener.positionX.setValueAtTime(x, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
        listener.positionY.setValueAtTime(y, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
        listener.positionZ.setValueAtTime(z, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
    } else listener.setPosition(x, y, z);
}
function $6992b783e25448c7$export$27298482267e128c(fx, fy, fz = -1, ux = 0, uy = 1, uz = 0) {
    const listener = $2f9e349157582da0$export$a078c61943f9dbbe.listener;
    if (listener.forwardX) {
        listener.forwardX.setValueAtTime(fx, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
        listener.forwardY.setValueAtTime(fy, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
        listener.forwardZ.setValueAtTime(fz, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
        listener.upX.setValueAtTime(ux, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
        listener.upY.setValueAtTime(uy, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
        listener.upZ.setValueAtTime(uz, $2f9e349157582da0$export$a078c61943f9dbbe.currentTime);
    } else listener.setOrientation(fx, fy, fz, ux, uy, uz);
}


/* eslint-disable no-use-before-define */ // Frequency Spectrum Visualisation Module
//
// Draws a live audio FFT horizontaly
// TODO:
// [] Add ability to reduce the bins drawn (divider?)
// [] Add a switch to display linear/exponential FFT
// [] Add smoothing option
// [] Add identification of signal spikes
// Utilities
//
// Project-wide utility functions
function $0e8da82cbafe8fa0$export$10ce5528abfb398a(source, dest) {
    // Overwrite destination object values for keys that exists in the source object
    Object.getOwnPropertyNames(dest).forEach((key)=>{
        if (Object.prototype.hasOwnProperty.call(source, key)) dest[key] = source[key];
    });
}
// Extract lines from a long string at word breaks before given length param
// Return an array of trimmed lines
function $0e8da82cbafe8fa0$export$89440da1893f4202(str, length) {
    const lines = [];
    if (str.length <= length) lines.push(str);
    else {
        let s = str;
        while(s.length > 0){
            let line;
            if (s.length > length) line = s.slice(0, s.slice(0, length).lastIndexOf(" "));
            else line = s;
            if (line.length > 0) {
                s = s.slice(line.length);
                lines.push(line.trim());
            } else s = "";
        }
    }
    return lines;
}
function $0e8da82cbafe8fa0$export$7d15b64cf5a3a4c4(value, min = 0, max = 1) {
    return Math.max(min, Math.min(value, max));
}
function $0e8da82cbafe8fa0$var$constrain(n, low, high) {
    return Math.max(Math.min(n, high), low);
}
let $0e8da82cbafe8fa0$var$newval;
function $0e8da82cbafe8fa0$export$aee1dbae5de2db9d(n, start1, stop1, start2, stop2, withinBounds) {
    $0e8da82cbafe8fa0$var$newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
    if (!withinBounds) return $0e8da82cbafe8fa0$var$newval;
    if (start2 < stop2) return $0e8da82cbafe8fa0$var$constrain($0e8da82cbafe8fa0$var$newval, start2, stop2);
    return $0e8da82cbafe8fa0$var$constrain($0e8da82cbafe8fa0$var$newval, stop2, start2);
}
function $0e8da82cbafe8fa0$export$2313b1b8de5d93a7(val) {
    return val * (100 / 1920) + "vw";
}
function $0e8da82cbafe8fa0$export$e6bfdeff8bfc94f9(deg) {
    return deg * Math.PI / 180;
}


let $c65faf8517c0b4a1$var$offscreen;
let $c65faf8517c0b4a1$var$ctx;
let $c65faf8517c0b4a1$var$width;
let $c65faf8517c0b4a1$var$height;
let $c65faf8517c0b4a1$var$divider;
// Module-global variables pulled out of their functions for better memory managment
let $c65faf8517c0b4a1$var$i; // Used in draw()
let $c65faf8517c0b4a1$var$x;
let $c65faf8517c0b4a1$var$h; // Used in draw()
// Default options
const $c65faf8517c0b4a1$var$options = {
    background: "transparent",
    color: "#ff8800",
    fftBins: 1024,
    noiseFloor: -140,
    lowerFreq: 0,
    upperFreq: 20000,
    gateThreshold: -50,
    detectionLineWidth: 2
};
function $c65faf8517c0b4a1$export$de27182ff8187d6c({ cellWidth: cellWidth, cellHeight: cellHeight, devicePixelRatio: devicePixelRatio }) {
    // Save these dimensions as module-scoped variables
    $c65faf8517c0b4a1$var$width = cellWidth * devicePixelRatio;
    $c65faf8517c0b4a1$var$height = cellHeight * devicePixelRatio;
    // Create an offscreen graphics buffer to draw in
    $c65faf8517c0b4a1$var$offscreen = new OffscreenCanvas($c65faf8517c0b4a1$var$width, $c65faf8517c0b4a1$var$height);
    $c65faf8517c0b4a1$var$ctx = $c65faf8517c0b4a1$var$offscreen.getContext("2d");
    // Fill in the background with a solid color
    $c65faf8517c0b4a1$var$ctx.fillStyle = $c65faf8517c0b4a1$var$options.background;
    $c65faf8517c0b4a1$var$ctx.clearRect(0, 0, $c65faf8517c0b4a1$var$width, $c65faf8517c0b4a1$var$height);
    // Set up some constants
    $c65faf8517c0b4a1$var$divider = 24000 / $c65faf8517c0b4a1$var$options.upperFreq;
}
function $c65faf8517c0b4a1$export$e529deb2bfd496dc(spectrumData) {
    if (spectrumData) {
        // Erase the graphics buffer with background color
        $c65faf8517c0b4a1$var$ctx.fillStyle = $c65faf8517c0b4a1$var$options.background;
        $c65faf8517c0b4a1$var$ctx.clearRect(0, 0, $c65faf8517c0b4a1$var$width, $c65faf8517c0b4a1$var$height);
        // Set FFT style
        $c65faf8517c0b4a1$var$ctx.fillStyle = $c65faf8517c0b4a1$var$options.color;
        // Draw FFT
        for($c65faf8517c0b4a1$var$i = 0; $c65faf8517c0b4a1$var$i < spectrumData.length / $c65faf8517c0b4a1$var$divider; $c65faf8517c0b4a1$var$i++){
            $c65faf8517c0b4a1$var$x = (0, $0e8da82cbafe8fa0$export$aee1dbae5de2db9d)($c65faf8517c0b4a1$var$i, 0, $c65faf8517c0b4a1$var$options.fftBins / $c65faf8517c0b4a1$var$divider, 0, $c65faf8517c0b4a1$var$width);
            $c65faf8517c0b4a1$var$h = -$c65faf8517c0b4a1$var$height + (0, $0e8da82cbafe8fa0$export$aee1dbae5de2db9d)(spectrumData[$c65faf8517c0b4a1$var$i], $c65faf8517c0b4a1$var$options.noiseFloor, 0, $c65faf8517c0b4a1$var$height, 0, true);
            $c65faf8517c0b4a1$var$ctx.fillRect($c65faf8517c0b4a1$var$x, $c65faf8517c0b4a1$var$height, $c65faf8517c0b4a1$var$width / spectrumData.length * $c65faf8517c0b4a1$var$divider, $c65faf8517c0b4a1$var$h);
        }
    }
    return $c65faf8517c0b4a1$var$offscreen.transferToImageBitmap();
}


// Waveform Visualisation Module
//
// Draws a live audio waveform horizontaly
// TODO:
// [] Make the waveform height exponential and constrained to the canvas height
// [] Add an option for a gain on waveform height

let $6e0ca08761e92e25$var$offscreen;
let $6e0ca08761e92e25$var$ctx;
let $6e0ca08761e92e25$var$width;
let $6e0ca08761e92e25$var$height;
// Module-global variables pulled out of their functions for better memory managment
let $6e0ca08761e92e25$var$i;
let $6e0ca08761e92e25$var$x;
let $6e0ca08761e92e25$var$y; // Used in draw()
const $6e0ca08761e92e25$var$options = {
    background: "black",
    color: "#ff8800",
    adaptPixelRatio: true,
    waveformLineWidth: 1
};
function $6e0ca08761e92e25$export$de27182ff8187d6c({ cellWidth: cellWidth, cellHeight: cellHeight, devicePixelRatio: devicePixelRatio }) {
    // Save these dimensions as module-scoped variables
    $6e0ca08761e92e25$var$width = cellWidth * devicePixelRatio;
    $6e0ca08761e92e25$var$height = cellHeight * devicePixelRatio;
    if ($6e0ca08761e92e25$var$options.adaptPixelRatio) {
        $6e0ca08761e92e25$var$width = cellWidth * devicePixelRatio;
        $6e0ca08761e92e25$var$height = cellHeight * devicePixelRatio;
        $6e0ca08761e92e25$var$options.waveformLineWidth *= devicePixelRatio;
    } else {
        $6e0ca08761e92e25$var$width = cellWidth;
        $6e0ca08761e92e25$var$height = cellHeight;
    }
    // Create an offscreen graphics buffer to draw in
    $6e0ca08761e92e25$var$offscreen = new OffscreenCanvas($6e0ca08761e92e25$var$width, $6e0ca08761e92e25$var$height);
    $6e0ca08761e92e25$var$ctx = $6e0ca08761e92e25$var$offscreen.getContext("2d");
    // Fill in the background with a solid color
    $6e0ca08761e92e25$var$ctx.fillStyle = $6e0ca08761e92e25$var$options.background;
    $6e0ca08761e92e25$var$ctx.clearRect(0, 0, $6e0ca08761e92e25$var$width, $6e0ca08761e92e25$var$height);
}
function $6e0ca08761e92e25$export$e529deb2bfd496dc(waveformData) {
    if (waveformData) {
        // Erase the graphics buffer with background color
        $6e0ca08761e92e25$var$ctx.clearRect(0, 0, $6e0ca08761e92e25$var$width, $6e0ca08761e92e25$var$height);
        // Set waveform style
        $6e0ca08761e92e25$var$ctx.strokeStyle = $6e0ca08761e92e25$var$options.color;
        $6e0ca08761e92e25$var$ctx.lineWidth = $6e0ca08761e92e25$var$options.waveformLineWidth;
        // Draw waveform
        $6e0ca08761e92e25$var$ctx.beginPath();
        for($6e0ca08761e92e25$var$i = 0; $6e0ca08761e92e25$var$i < waveformData.length; $6e0ca08761e92e25$var$i++){
            $6e0ca08761e92e25$var$x = (0, $0e8da82cbafe8fa0$export$aee1dbae5de2db9d)($6e0ca08761e92e25$var$i, 0, waveformData.length, 0, $6e0ca08761e92e25$var$width);
            $6e0ca08761e92e25$var$y = (0, $0e8da82cbafe8fa0$export$aee1dbae5de2db9d)(waveformData[$6e0ca08761e92e25$var$i] * 8, -1, 1, 0, $6e0ca08761e92e25$var$height); // FIXME: this * 8 is hacky, dig in...
            $6e0ca08761e92e25$var$ctx.lineTo($6e0ca08761e92e25$var$x, $6e0ca08761e92e25$var$y);
        }
        $6e0ca08761e92e25$var$ctx.stroke();
        $6e0ca08761e92e25$var$ctx.closePath();
    }
    return $6e0ca08761e92e25$var$offscreen.transferToImageBitmap();
}



var $9e438805536e4247$exports = {};

$9e438805536e4247$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../carte-topo.c072b3db.png";


var $5d929188375f1687$exports = {};

$5d929188375f1687$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../mic.d05ce39f.png";


const $179c70bbebd962c0$var$images = [
    {
        name: "background",
        url: new URL($9e438805536e4247$exports)
    },
    {
        name: "mic",
        url: new URL($5d929188375f1687$exports)
    }
];
var $4233e3fd46416b9b$exports = {};

$4233e3fd46416b9b$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../TestLR.c41b1ab3.m4a";


var $78cf93477cf15ee2$exports = {};

$78cf93477cf15ee2$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../SoundEscape.ddf2b7c4.m4a";


var $be0febea655b72da$exports = {};

$be0febea655b72da$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../DescriptionAlo.e3845da4.m4a";


var $393f155644e0e927$exports = {};

$393f155644e0e927$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../DescriptionBern.3fbe4433.m4a";


var $9de1c027149d3d18$exports = {};

$9de1c027149d3d18$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../DescriptionIsa.f07d445e.m4a";


var $c273bb8c9c237cd9$exports = {};

$c273bb8c9c237cd9$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../DescriptionLeon.433bd7ac.m4a";


var $9dd290e0793f5d16$exports = {};

$9dd290e0793f5d16$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../DescriptionLouve.f90e36c0.m4a";


var $c23b1faa58124fa5$exports = {};

$c23b1faa58124fa5$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../DescriptionMic.9f0ecbff.m4a";


var $3e546db6b5f934e4$exports = {};

$3e546db6b5f934e4$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../DescriptionNico.3671b546.m4a";


var $becbeb60ad39c822$exports = {};

$becbeb60ad39c822$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../DescriptionVJ.66bb408d.m4a";


var $e22649ec5455cda2$exports = {};

$e22649ec5455cda2$exports = (parcelRequire("aNJCr")).getBundleURL("gTtyq") + "../DescriptionYves.aaa963cc.m4a";


const $179c70bbebd962c0$var$sounds = [
    {
        name: "test-headphone",
        url: new URL($4233e3fd46416b9b$exports)
    },
    {
        name: "signal",
        url: new URL($78cf93477cf15ee2$exports)
    },
    {
        name: "commentaire1",
        url: new URL($be0febea655b72da$exports)
    },
    {
        name: "commentaire2",
        url: new URL($393f155644e0e927$exports)
    },
    {
        name: "commentaire3",
        url: new URL($9de1c027149d3d18$exports)
    },
    {
        name: "commentaire4",
        url: new URL($c273bb8c9c237cd9$exports)
    },
    {
        name: "commentaire5",
        url: new URL($9dd290e0793f5d16$exports)
    },
    {
        name: "commentaire6",
        url: new URL($c23b1faa58124fa5$exports)
    },
    {
        name: "commentaire7",
        url: new URL($3e546db6b5f934e4$exports)
    },
    {
        name: "commentaire8",
        url: new URL($becbeb60ad39c822$exports)
    },
    {
        name: "commentaire9",
        url: new URL($e22649ec5455cda2$exports)
    }
];
const $179c70bbebd962c0$var$commentaries = [
    {
        name: "commentaire1",
        x: 510,
        y: 275
    },
    {
        name: "commentaire2",
        x: 420,
        y: 370
    },
    {
        name: "commentaire3",
        x: 400,
        y: 735
    },
    {
        name: "commentaire4",
        x: 635,
        y: 240
    },
    {
        name: "commentaire5",
        x: 760,
        y: 685
    },
    {
        name: "commentaire6",
        x: 1345,
        y: 205
    },
    {
        name: "commentaire7",
        x: 1445,
        y: 435
    },
    {
        name: "commentaire8",
        x: 1480,
        y: 260
    },
    {
        name: "commentaire9",
        x: 1245,
        y: 810
    },
    {
        name: "commentaire1",
        x: 1909,
        y: 93
    },
    {
        name: "commentaire2",
        x: 1888,
        y: 847
    },
    {
        name: "commentaire3",
        x: 1088,
        y: 356
    },
    {
        name: "commentaire4",
        x: 96,
        y: 894
    },
    {
        name: "commentaire5",
        x: 1807,
        y: 108
    },
    {
        name: "commentaire6",
        x: 596,
        y: 886
    },
    {
        name: "commentaire7",
        x: 102,
        y: 433
    },
    {
        name: "commentaire8",
        x: 746,
        y: 940
    },
    {
        name: "commentaire9",
        x: 1013,
        y: 63
    }
];
const $179c70bbebd962c0$var$screen = document.querySelector(".screen");
const $179c70bbebd962c0$var$micEl = document.querySelector(".mic");
const $179c70bbebd962c0$var$joystickEl = document.querySelector(".joystick");
const $179c70bbebd962c0$var$worldSize = {
    width: 3840,
    height: 2160
};
const $179c70bbebd962c0$var$joystickSize = 60;
const $179c70bbebd962c0$var$commentarySize = 12;
const $179c70bbebd962c0$var$mic = {
    position: {
        x: 611,
        y: 412
    },
    rotation: -11,
    damping: 0.08,
    speed: 0,
    turnSpeed: 0,
    acceleration: 0.1
};
const $179c70bbebd962c0$var$positionOffset = {
    x: 0,
    y: 0
};
const $179c70bbebd962c0$var$coordinatesMultiplier = 2; // Coordinates are in FHD, world is in 4K
const $179c70bbebd962c0$var$keys = {};
const $179c70bbebd962c0$var$touch = {
    active: false,
    startX: 0,
    startY: 0,
    xAxis: 0,
    yAxis: 0
};
function $179c70bbebd962c0$export$2cd8252107eb640b() {
    // Register window resize event
    window.addEventListener("resize", ()=>{
        $179c70bbebd962c0$var$updateMicElPos();
        $179c70bbebd962c0$var$updateCommentariesPos();
    });
    // Register keyboard events
    window.addEventListener("keydown", (e)=>{
        $179c70bbebd962c0$var$keys[e.key] = true;
    });
    window.addEventListener("keyup", (e)=>{
        $179c70bbebd962c0$var$keys[e.key] = false;
    });
    // Register touch events
    window.addEventListener("touchstart", (e)=>{
        $179c70bbebd962c0$var$touch.active = true;
        $179c70bbebd962c0$var$touch.startX = e.touches[0].clientX;
        $179c70bbebd962c0$var$touch.startY = e.touches[0].clientY;
        $179c70bbebd962c0$var$joystickEl.style.translate = `${$179c70bbebd962c0$var$touch.startX - $179c70bbebd962c0$var$joystickSize / 2}px ${$179c70bbebd962c0$var$touch.startY - $179c70bbebd962c0$var$joystickSize / 2}px`;
        $179c70bbebd962c0$var$joystickEl.style.opacity = 0.5;
    });
    window.addEventListener("touchmove", (e)=>{
        const halfJoy = $179c70bbebd962c0$var$joystickSize / 2;
        // Get touch move position
        let moveX = e.touches[0].clientX;
        let moveY = e.touches[0].clientY;
        // Calculate joystick delta
        let deltaX = moveX - $179c70bbebd962c0$var$touch.startX;
        let deltaY = moveY - $179c70bbebd962c0$var$touch.startY;
        // Calculate joystick distance
        const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2);
        // Constrain joystick to its size
        if (distance > halfJoy) {
            const angle = Math.atan2(deltaY, deltaX);
            deltaX = Math.cos(angle) * halfJoy;
            deltaY = Math.sin(angle) * halfJoy;
            moveX = $179c70bbebd962c0$var$touch.startX + deltaX;
            moveY = $179c70bbebd962c0$var$touch.startY + deltaY;
        }
        $179c70bbebd962c0$var$touch.xAxis = deltaX / halfJoy;
        $179c70bbebd962c0$var$touch.yAxis = deltaY / halfJoy;
        // Update joystick position
        $179c70bbebd962c0$var$joystickEl.style.translate = `${moveX - halfJoy}px ${moveY - halfJoy}px`;
    });
    window.addEventListener("touchend", (e)=>{
        $179c70bbebd962c0$var$touch.active = false;
        $179c70bbebd962c0$var$joystickEl.style.opacity = 0;
    });
}
function $179c70bbebd962c0$export$11e63f7b0f3d9900() {
    return Promise.all([
        $179c70bbebd962c0$var$loadSounds(),
        $179c70bbebd962c0$var$loadImages()
    ]);
}
function $179c70bbebd962c0$export$b3571188c770cc5a() {
    if (DEVMODE) console.log("Scene started");
    $179c70bbebd962c0$var$updateMicElPos();
    // Play signal
    const signal = $12429086d032ace0$exports.play("signal", {
        loop: true
    });
    // Setup spectrum audio analyser
    const spectrumAudioAnalyser = $2f9e349157582da0$export$a078c61943f9dbbe.createAnalyser();
    const fftBins = 1024;
    spectrumAudioAnalyser.fftSize = fftBins * 2;
    spectrumAudioAnalyser.smoothingTimeConstant = 0.0;
    const spectrumData = new Float32Array(fftBins);
    signal.gainNode.connect(spectrumAudioAnalyser);
    // Setup spectrum module
    const spectrumCanvas = document.querySelector("#spectrum");
    spectrumCanvas.width = 250;
    spectrumCanvas.height = 74;
    $c65faf8517c0b4a1$export$de27182ff8187d6c({
        cellWidth: spectrumCanvas.width,
        cellHeight: spectrumCanvas.height,
        devicePixelRatio: 1
    });
    // Get spectrum canvas context
    const spectrumCtx = spectrumCanvas.getContext("2d");
    // Setup waveform module
    const waveformCanvas = document.querySelector("#waveform");
    waveformCanvas.width = 250;
    waveformCanvas.height = 74;
    $6e0ca08761e92e25$export$de27182ff8187d6c({
        cellWidth: waveformCanvas.width,
        cellHeight: waveformCanvas.height,
        devicePixelRatio: 1
    });
    // Get waveform canvas context
    const waveformCtx = waveformCanvas.getContext("2d");
    // Setup waveform audio analyser
    const waveformAudioAnalyser = $2f9e349157582da0$export$a078c61943f9dbbe.createAnalyser();
    spectrumAudioAnalyser.fftSize = fftBins * 2;
    spectrumAudioAnalyser.smoothingTimeConstant = 0.0;
    const waveformData = new Float32Array(fftBins);
    $179c70bbebd962c0$var$commentaries.forEach((commentary)=>{
        // Create panner
        const panner = (0, $6992b783e25448c7$export$604289ae06b8fa82)();
        panner.positionPanner(commentary.x, 0, commentary.y);
        // Play commentaries
        const sound = $12429086d032ace0$exports.play(commentary.name, {
            loop: true,
            destination: panner
        });
        panner.connect(waveformAudioAnalyser);
        // Add commentary to the screen
        const el = document.createElement("div");
        el.classList.add("commentary");
        el.classList.add(commentary.name);
        $179c70bbebd962c0$var$screen.appendChild(el);
        commentary.el = el;
    });
    $179c70bbebd962c0$var$updateCommentariesPos();
    loop();
    function loop() {
        // Update mic speed and rotation from keyboard
        if ($179c70bbebd962c0$var$keys.ArrowUp) $179c70bbebd962c0$var$mic.speed += $179c70bbebd962c0$var$mic.acceleration;
        if ($179c70bbebd962c0$var$keys.ArrowDown) $179c70bbebd962c0$var$mic.speed -= $179c70bbebd962c0$var$mic.acceleration;
        if ($179c70bbebd962c0$var$keys.ArrowLeft) $179c70bbebd962c0$var$mic.turnSpeed -= $179c70bbebd962c0$var$mic.acceleration;
        if ($179c70bbebd962c0$var$keys.ArrowRight) $179c70bbebd962c0$var$mic.turnSpeed += $179c70bbebd962c0$var$mic.acceleration;
        // Update mic speed and rotation from touch
        if ($179c70bbebd962c0$var$touch.active) {
            $179c70bbebd962c0$var$mic.speed += $179c70bbebd962c0$var$mic.acceleration * -$179c70bbebd962c0$var$touch.yAxis;
            $179c70bbebd962c0$var$mic.turnSpeed += $179c70bbebd962c0$var$mic.acceleration * $179c70bbebd962c0$var$touch.xAxis;
        }
        // Update mic
        $179c70bbebd962c0$var$mic.speed *= 1 - $179c70bbebd962c0$var$mic.damping;
        $179c70bbebd962c0$var$mic.turnSpeed *= 1 - $179c70bbebd962c0$var$mic.damping;
        $179c70bbebd962c0$var$mic.position.x += Math.cos((0, $0e8da82cbafe8fa0$export$e6bfdeff8bfc94f9)($179c70bbebd962c0$var$mic.rotation - 90)) * $179c70bbebd962c0$var$mic.speed;
        $179c70bbebd962c0$var$mic.position.y += Math.sin((0, $0e8da82cbafe8fa0$export$e6bfdeff8bfc94f9)($179c70bbebd962c0$var$mic.rotation - 90)) * $179c70bbebd962c0$var$mic.speed;
        $179c70bbebd962c0$var$mic.rotation += $179c70bbebd962c0$var$mic.turnSpeed;
        // Constrain position to topographic map boundaries
        const margin = 20;
        $179c70bbebd962c0$var$mic.position.x = Math.max(margin, Math.min($179c70bbebd962c0$var$mic.position.x, $179c70bbebd962c0$var$worldSize.width / $179c70bbebd962c0$var$coordinatesMultiplier - margin));
        $179c70bbebd962c0$var$mic.position.y = Math.max(margin, Math.min($179c70bbebd962c0$var$mic.position.y, $179c70bbebd962c0$var$worldSize.height / $179c70bbebd962c0$var$coordinatesMultiplier - margin));
        // Offset background position, mic position and commentaries position
        // when mic is near the edge of the screen
        const screenPos = $179c70bbebd962c0$var$worldToScreenPosition($179c70bbebd962c0$var$mic.position);
        if (screenPos.x < $179c70bbebd962c0$var$screen.clientWidth / 4) $179c70bbebd962c0$var$positionOffset.x = $179c70bbebd962c0$var$screen.clientWidth / 4 - screenPos.x;
        else if (screenPos.x > $179c70bbebd962c0$var$screen.clientWidth * 3 / 4) $179c70bbebd962c0$var$positionOffset.x = $179c70bbebd962c0$var$screen.clientWidth * 3 / 4 - screenPos.x;
        else $179c70bbebd962c0$var$positionOffset.x = 0;
        if (screenPos.y < $179c70bbebd962c0$var$screen.clientHeight / 4) $179c70bbebd962c0$var$positionOffset.y = $179c70bbebd962c0$var$screen.clientHeight / 4 - screenPos.y;
        else if (screenPos.y > $179c70bbebd962c0$var$screen.clientHeight * 3 / 4) $179c70bbebd962c0$var$positionOffset.y = $179c70bbebd962c0$var$screen.clientHeight * 3 / 4 - screenPos.y;
        else $179c70bbebd962c0$var$positionOffset.y = 0;
        $179c70bbebd962c0$var$screen.style.backgroundPosition = `calc(50% + ${$179c70bbebd962c0$var$positionOffset.x}px) calc(50% + ${$179c70bbebd962c0$var$positionOffset.y}px)`;
        $179c70bbebd962c0$var$updateMicElPos();
        $179c70bbebd962c0$var$updateCommentariesPos();
        // 3D HRTF panning
        (0, $6992b783e25448c7$export$f0551cbb67220cad)($179c70bbebd962c0$var$mic.position.x, 0, $179c70bbebd962c0$var$mic.position.y);
        const deltaAngleX = Math.abs($179c70bbebd962c0$var$mic.rotation + 90) % 360;
        const deviationX = deltaAngleX < 180 ? deltaAngleX : 360 - deltaAngleX;
        const deltaAngleZ = Math.abs($179c70bbebd962c0$var$mic.rotation) % 360;
        const deviationZ = deltaAngleZ < 180 ? deltaAngleZ : 360 - deltaAngleZ;
        (0, $6992b783e25448c7$export$27298482267e128c)(deviationX / 180 * 2 - 1, 0, deviationZ / 180 * 2 - 1);
        // Draw spectrum
        spectrumAudioAnalyser.getFloatFrequencyData(spectrumData);
        spectrumCtx.clearRect(0, 0, spectrumCanvas.width, spectrumCanvas.height);
        spectrumCtx.drawImage($c65faf8517c0b4a1$export$e529deb2bfd496dc(spectrumData), 0, 0);
        spectrumCtx.fillStyle = "#ff8800";
        spectrumCtx.font = "14px Source Code Pro";
        spectrumCtx.fillText(`Signal spectrum`, 5, 16);
        // Draw waveform
        waveformAudioAnalyser.getFloatTimeDomainData(waveformData);
        waveformCtx.clearRect(0, 0, waveformCanvas.width, waveformCanvas.height);
        waveformCtx.drawImage($6e0ca08761e92e25$export$e529deb2bfd496dc(waveformData), 0, 0);
        waveformCtx.fillStyle = "#ff8800";
        waveformCtx.font = "14px Source Code Pro";
        waveformCtx.fillText(`Microphone waveform`, 5, 16);
        requestAnimationFrame(loop);
    }
}
function $179c70bbebd962c0$var$loadSounds() {
    return Promise.all([
        ...$179c70bbebd962c0$var$sounds.map((sound)=>{
            return $12429086d032ace0$exports.load(sound.name, sound.url);
        })
    ]).then(()=>{
        if (DEVMODE) console.log("All sounds loaded");
    });
}
function $179c70bbebd962c0$var$loadImages() {
    return Promise.all([
        ...$179c70bbebd962c0$var$images.map((image)=>{
            return new Promise((resolve, reject)=>{
                const img = new Image();
                img.onload = ()=>{
                    if (DEVMODE) console.log(`Image ${image.name} loaded`);
                    resolve();
                };
                img.onerror = ()=>{
                    reject(`Error loading image ${image.name}`);
                };
                img.src = image.url;
            });
        })
    ]).then(()=>{
        if (DEVMODE) console.log("All images loaded");
    });
}
function $179c70bbebd962c0$var$updateMicElPos() {
    const screenPos = $179c70bbebd962c0$var$worldToScreenPosition($179c70bbebd962c0$var$mic.position);
    $179c70bbebd962c0$var$micEl.style.translate = `${$179c70bbebd962c0$var$positionOffset.x + screenPos.x}px ${$179c70bbebd962c0$var$positionOffset.y + screenPos.y}px`;
    $179c70bbebd962c0$var$micEl.style.rotate = `${$179c70bbebd962c0$var$mic.rotation}deg`;
    $179c70bbebd962c0$var$micEl.style.scale = `${screenPos.scale}`;
}
function $179c70bbebd962c0$var$updateCommentariesPos() {
    $179c70bbebd962c0$var$commentaries.forEach((commentary)=>{
        const screenPos = $179c70bbebd962c0$var$worldToScreenPosition(commentary);
        commentary.el.style.translate = `${$179c70bbebd962c0$var$positionOffset.x + screenPos.x - $179c70bbebd962c0$var$commentarySize / 2}px ${$179c70bbebd962c0$var$positionOffset.y + screenPos.y - $179c70bbebd962c0$var$commentarySize / 2}px`;
        commentary.el.style.scale = `${screenPos.scale}`;
    });
}
function $179c70bbebd962c0$var$worldToScreenPosition(worldPos) {
    // Screen background-size is set to cover
    const screenRatio = $179c70bbebd962c0$var$screen.clientWidth / $179c70bbebd962c0$var$screen.clientHeight;
    const worldRatio = $179c70bbebd962c0$var$worldSize.width / $179c70bbebd962c0$var$worldSize.height;
    let scale = 1;
    if (screenRatio > worldRatio) {
        // Screen less tall than the world
        // Topography is clipped on the top and bottom
        scale = $179c70bbebd962c0$var$screen.clientWidth / $179c70bbebd962c0$var$worldSize.width;
        return {
            x: $179c70bbebd962c0$var$coordinatesMultiplier * worldPos.x * scale,
            y: $179c70bbebd962c0$var$coordinatesMultiplier * worldPos.y * scale - ($179c70bbebd962c0$var$worldSize.height * scale - $179c70bbebd962c0$var$screen.clientHeight) / 2,
            scale: $179c70bbebd962c0$var$coordinatesMultiplier * scale
        };
    } else {
        // Screen is less wide than the world
        // Topography is clipped on the sides
        scale = $179c70bbebd962c0$var$screen.clientHeight / $179c70bbebd962c0$var$worldSize.height;
        return {
            x: $179c70bbebd962c0$var$coordinatesMultiplier * worldPos.x * scale - ($179c70bbebd962c0$var$worldSize.width * scale - $179c70bbebd962c0$var$screen.clientWidth) / 2,
            y: $179c70bbebd962c0$var$coordinatesMultiplier * worldPos.y * scale,
            scale: $179c70bbebd962c0$var$coordinatesMultiplier * scale
        };
    }
}


// Development
window.DEVMODE = true;
function $aeba43b1d865609c$var$init() {
    $19e595a4b41a11be$export$2cd8252107eb640b();
    $19e595a4b41a11be$export$471f7ae5c4103ae1("Initializing...");
    $2f9e349157582da0$export$2cd8252107eb640b();
    $19e595a4b41a11be$export$471f7ae5c4103ae1("Loading...");
    $179c70bbebd962c0$export$2cd8252107eb640b();
    $179c70bbebd962c0$export$11e63f7b0f3d9900().then(()=>{
        $19e595a4b41a11be$export$4bb981a91e4f02eb();
    });
}
function $aeba43b1d865609c$export$b3571188c770cc5a() {
    $179c70bbebd962c0$export$b3571188c770cc5a();
}
$aeba43b1d865609c$var$init();

})();
//# sourceMappingURL=index.24c7fd9f.js.map
